/* eslint-disable react-hooks/exhaustive-deps */
// react
import {
  Container,
  Row,
  Col,
  Card,
  Collapse,
  Button,
  Form,
  Table,
} from "react-bootstrap"
import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"

// wijmo
import * as wjGrid from "@grapecity/wijmo.grid"

// fortawasome
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// other
import { AppDispatch } from "../../../.."
import gridPageHelper from "../../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../../ts/helpers/pageHelper"

// Kairos
import AlertComponent from "../../../../components/AlertComponent"
import ComboBox from "../../../../components/ComboBox"
import util from "../../../../ts/util"

import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { T部所マスタ } from "../../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import DisplaySearchConditionLabel from "../../../../components/DisplaySearchConditionLabel"
import TextInput from "../../../../components/InputWrapper/TextInput"
import CheckInput from "../../../../components/InputWrapper/CheckInput"
import Spinner from "../../../../components/Spinner"
import { showInfoToast } from "../../../../components/CustomToast"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import { 区分分類コード } from "../../../../constant/enum/codes"

import { RootState } from "../../../../globalStore/rootreducer"
import {
  clearAlert,
  setAlerts,
  setInfoAlerts,
} from "../../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../../globalStore/progressStore"
import { TWijmoComboBox } from "../../../../type/wijmoComponents"
import {
  TInvoiceRegisterListGetReq,
  TInvoiceRegisterListGetRes,
  TInvoiceRegisterListPutReq,
  TInvoiceRegisterZyutyuHaisya,
  TInvoiceRegisterSekisaiHin,
  TInvoiceRegisterListPutRes,
} from "../../../../service/billing/invoice/TInvoice"
import { TApiResponse } from "../../../../service/TApiResponse"
import InvoiceListService from "../../../../service/billing/invoice/invoiceListService"

import InvoiceListGrid from "./InvoiceListGrid"
import { InvoiceListProvider } from "./InvoiceListContext"
import { T社員マスタ } from "../../../../components/ComboBox/SyainComboBox"
import BusyoService from "../../../../service/master/busyo/busyoService"
import KubunService from "../../../../service/master/kubun/kubunService"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"
import SyainService from "../../../../service/master/syain/syainService"
import CONSTANT from "../../../../constant"
import MESSAGES from "../../../../constant/messages"
import _ from "lodash"

export type T請求明細入力GridItem = TInvoiceRegisterListGetRes & {
  is更新エラー?: boolean
  is正常更新?: boolean
}

// 検索条件と表示用検索条件
type TOmitDisplay =
  | "表紙分割コード"
  | "請求内訳コード"
  | "請求内訳担当コード"
  | "運行部所コード"
  | "請求額確認区分コード"
  | "傭車会社あり対象フラグ"
  | "表示順区分コード"

type T表示用検索条件 = Omit<TInvoiceRegisterListGetReq, TOmitDisplay> &
  Partial<{
    表紙分割?: string
    請求内訳?: string
    請求内訳担当?: string
    運行部所?: string
    請求額確認区分?: string
    傭車あり: boolean
    表示順区分: string
  }>

/**
 * 請求明細一覧
 * @returns
 */
const InvoiceList = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : 0
  const dispatch: AppDispatch = useDispatch()

  const { zengetuStr: 前月 } = useSelector((state: RootState) => state.date)

  const [accordionController, setAccordionController] = useState(true)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //TODO:ページ名称確定必須
  let gridId = "InvoiceList_GridId"

  //#region [state]

  // 画面共通
  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<T表示用検索条件>()

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [searchResult, setSearchResult] = useState<T請求明細入力GridItem[]>()

  const [請求年月, set請求年月] = useState<string>(前月)
  //TODO:テスト用に初期値入力
  const [荷主コード, set荷主コード] = useState<string | undefined>("1")
  const [荷主名, set荷主名] = useState<string>()
  const [表紙分割名, set表紙分割名] = useState<string>()
  const [荷主請求内訳ID, set荷主請求内訳ID] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()
  const [品コード, set品コード] = useState<string>()
  const [品名, set品名] = useState<string>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [荷主依頼番号, set荷主依頼番号] = useState<string>()
  const [コンテナNO, setコンテナNO] = useState<string>()
  const [積地コード, set積地コード] = useState<string>()
  const [卸地コード, set卸地コード] = useState<string>()
  const [積地地名, set積地地名] = useState<string>()
  const [積地社名, set積地社名] = useState<string>()
  const [卸地地名, set卸地地名] = useState<string>()
  const [卸地社名, set卸地社名] = useState<string>()
  const [車番, set車番] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()
  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [請求内訳担当コード, set請求内訳担当コード] = useState<
    T社員マスタ["社員コード"] | null
  >(null)
  const [請求内訳担当ItemSource, set請求内訳担当ItemSource] =
    useState<T社員マスタ[]>()

  const [請求額確認区分コード, set請求額確認区分コード] = useState<
    string | null
  >()
  const [請求処理状態区分コード, set請求処理状態区分コード] = useState<
    string | null
  >()
  const [傭車会社あり対象フラグ, set傭車会社あり対象フラグ] = useState(0)
  const [表示順区分コード, set表示順区分コード] = useState<string | null>()

  // 更新 処理用
  const [請求合計更新日時, set請求合計更新日時] = useState<string | null>()
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [comboboxState]
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)
  // 請求内訳担当
  const [請求内訳担当ComboBox, set請求内訳担当ComboBox] =
    useState<TWijmoComboBox<string, T社員マスタ> | null>(null)
  const [請求内訳担当isLoadEnded, set請求内訳担当isLoadEnded] =
    useState<boolean>(false)
  // 運行場所
  const [運行部所ComboBox, set運行部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [運行部所isLoadEnded, set運行部所isLoadEnded] = useState<boolean>(false)

  // 請求額確認
  const [請求額確認区分ComboBox, set請求額確認区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [請求額確認区分isLoadEnded, set請求額確認区分isLoadEnded] =
    useState<boolean>(false)

  // 表示順
  const [表示順区分ComboBox, set表示順区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [表示順区分isLoadEnded, set表示順区分isLoadEnded] =
    useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new SyainService().getList({
        部所コード: CONSTANT.事務センター部所コード,
      }),
    ]).then(([部所ListRes, 区分マスタRes, 請求内訳担当Res]) => {
      部所ListRes && set部所ItemSource([...部所ListRes.data])
      区分マスタRes && set区分ItemSource(区分マスタRes.data)

      請求内訳担当Res &&
        set請求内訳担当ItemSource(
          請求内訳担当Res.data.filter((i: T社員マスタ) => {
            return i.請求担当フラグ === 1
          })
        )
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時は常に検索を行う
      // 検索
      search().finally(() => {
        dispatch(画面ロック解除())
      })

      if (location.search !== "") {
        // リストア中フラグON
        setIsRestoreSearching(true)
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  //#endregion

  //#region [method]

  /**
   * 検索
   */
  const search = async (
    searchCondition?: TInvoiceRegisterListGetReq,
    putRes?: TApiResponse<TInvoiceRegisterListPutRes>
  ) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TInvoiceRegisterListGetReq | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const service = new InvoiceListService()

      const res = await service.getList(currentSearchCondition)

      res.data.forEach((row) => {
        if (row.受注伝票番号 != null) {
          row.受注伝票番号 = row.受注伝票番号 + "-" + row.受注枝番
        }

        //（一次対応）トン数補償フラグの設定有無のみを画面表示する
        if (row.トン数補償フラグ === 1) {
          row.トン数補償内容 = "あり"
        }
      })
      setSearchResult([
        ...res.data.map((d) => {
          return {
            is正常更新:
              putRes == null
                ? undefined
                : putRes.data.受注配車IDList_正常.some(
                    (n) => n === d.受注配車ID
                  ),
            is更新エラー:
              putRes == null
                ? undefined
                : putRes.data.受注配車IDList_エラー.some(
                    (n) => n === d.受注配車ID
                  ),
            ...d,
          }
        }),
      ])

      if (res && res.data.length <= 0) {
        dispatch(setInfoAlerts(["検索条件に該当する請求データが存在しません"]))
        return
      }

      // 請求合計テーブル更新用
      set請求合計更新日時(
        res.data[0].請求合計更新日時 ? res.data[0].請求合計更新日時 : ""
      )

      // 検索条件の初期設定
      set請求年月(res.data[0].請求年月 ? res.data[0].請求年月 : "")
      set荷主コード(res.data[0].荷主コード ? res.data[0].荷主コード : "")
      set荷主名(res.data[0].荷主名 ? res.data[0].荷主名 : "")
      set表紙分割名(res.data[0].表紙名 ? res.data[0].表紙名 : "")

      if (!請求内訳IsLoadEnded) {
        const 請求内訳Res = await new NinusiSeikyuService().getListUchiwake({
          荷主請求IdList: _.uniq(res.data.map((s) => s.荷主請求ID)),
        })
        set請求内訳ItemSource(請求内訳Res.data)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TInvoiceRegisterListGetReq => {
    return {
      請求合計ID: id,
      荷主請求内訳ID: 荷主請求内訳ID === 0 ? null : 荷主請求内訳ID,
      品コード: 品コード ?? undefined,
      品名: 品名 ?? undefined,
      表示順: 表示順区分コード ?? "1",
      積地コード: 積地コード ?? undefined,
      積地社名: 積地社名 ?? undefined,
      積地地名: 積地地名 ?? undefined,
      卸地コード: 卸地コード ?? undefined,
      卸地社名: 卸地社名 ?? undefined,
      卸地地名: 卸地地名 ?? undefined,
      車番: 車番 ?? undefined,
      乗務員名: 乗務員名 ?? undefined,
      請求額確認区分コード: 請求額確認区分コード ?? undefined,
      荷主依頼番号: 荷主依頼番号 ?? undefined,
      コンテナNO: コンテナNO ?? undefined,
      運行部所コード: 運行部所コード ?? undefined,
      請求内訳担当者コード: 請求内訳担当コード ?? undefined,
      傭車チェック: 傭車会社あり対象フラグ === 1 ?? undefined,
    }
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TInvoiceRegisterListGetReq
  ): T表示用検索条件 | undefined => {
    return {
      荷主コード: searchCondition.荷主コード,
      荷主名: searchCondition.荷主名,
      請求内訳: 請求内訳ItemSource?.find(
        (i) => i.荷主請求内訳ID === searchCondition.荷主請求内訳ID
      )?.請求内訳名,
      品名: searchCondition.品名,
      品コード: searchCondition.品コード,
      荷主依頼番号: searchCondition.荷主依頼番号,
      積地コード: searchCondition.積地コード,
      積地社名: searchCondition.卸地社名,
      積地地名: searchCondition.積地地名,
      卸地コード: searchCondition.卸地コード,
      卸地社名: searchCondition.卸地社名,
      卸地地名: searchCondition.卸地地名,
      車番: searchCondition.車番,
      乗務員名: searchCondition.乗務員名,
      運行部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.運行部所コード
      )?.部所名,
      請求額確認区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.請求額確認区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.請求支払確認区分
      )?.名称1,
      傭車あり: searchCondition.傭車チェック,
      表示順区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.表示順 &&
          i.分類コード ===
            区分分類コード.受注配車_請求支払.請求明細一覧表示順区分
      )?.名称1,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認

      const zyutyuHaisyaList: TInvoiceRegisterZyutyuHaisya[] = []
      const sekisaiHinList: TInvoiceRegisterSekisaiHin[] = []

      let 受注情報識別ID: number = 0

      flexGrid?.collectionView.sourceCollection.forEach(
        (row: TInvoiceRegisterListGetRes) => {
          // 受注配車情報
          if (row.請求区分コード === "2") {
            //「請求区分：品数毎」の場合
            受注情報識別ID = row.積載品ID
          } else {
            受注情報識別ID = 0
          }
          let zyutyuHaisyaRow: TInvoiceRegisterZyutyuHaisya = {
            受注配車ID: row.受注配車ID,
            積載品ID: 受注情報識別ID,
            請求区分コード: row.請求区分コード,
            請求計上日: row.請求計上日,
            請求車番: row.請求車番,
            荷主請求内訳ID: row.荷主請求内訳ID,
            請求運送料課税区分コード: row.請求運送料課税区分コード,
            請求運送料: row.運送料 ?? 0,
            請求付帯料課税区分コード: row.請求付帯料課税区分コード,
            請求付帯料: row.付帯料 ?? 0,
            請求高速料: row.請求高速料 ?? 0,
            荷主依頼番号: row.荷主依頼番号,
            コンテナNO: row.コンテナNO,
            請求備考: row.請求備考,
            請求額確認区分コード: row.請求額確認区分コード,
            更新日時: row.受注配車更新日時,
          }
          zyutyuHaisyaList.push(zyutyuHaisyaRow)

          // 積載品情報
          if (row.請求区分コード === "2") {
            //「請求区分：品数毎」の場合
            let sekisaiHinRow: TInvoiceRegisterSekisaiHin = {
              受注配車ID: row.受注配車ID,
              積載品ID: row.積載品ID,
              単価: row.単価 ?? 0,
              運送料: row.運送料 ?? 0,
              付帯料: row.付帯料 ?? 0,
              更新日時: row.積載品更新日時,
            }
            sekisaiHinList.push(sekisaiHinRow)
          }
        }
      )

      const data: TInvoiceRegisterListPutReq = {
        受注配車情報リスト: zyutyuHaisyaList,
        積載品情報リスト: sekisaiHinList,
        請求合計ID: id,
        請求処理状態区分コード: 請求処理状態区分コード,
        更新日時: 請求合計更新日時 ?? undefined,
      }

      const service = new InvoiceListService()
      const res = await service.put(id, data)

      console.log(res)

      // 更新できなかった行が存在した場合W4001が設定されている
      // フロント側では受注Noを赤く塗る対応を行っているため、エラーメッセージをすり替えてその旨を通知する
      const w4001Warn = res.warns.find((w) => w.code === "W4001")
      if (w4001Warn != null) {
        w4001Warn.message = MESSAGES.WARNS.W4001
        w4001Warn.messageWithCode = `${w4001Warn.code}:${MESSAGES.WARNS.W4001}`
      }

      // メッセージ反映
      dispatch(setAlerts(res))

      if (res) {
        // 更新後の再検索
        search(undefined, res).finally(() => {
          dispatch(画面ロック解除())
        })
        isPrompt.current = false
        showInfoToast(`請求明細の${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion
  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">請求明細一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card>
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body id="collapse-search-card-body">
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <Table className="search-table">
                            <tbody>
                              <tr>
                                <td>
                                  <div className="input-group">
                                    <div className="w-6rem">
                                      <TextInput
                                        id="請求年月"
                                        name="請求年月"
                                        placeholder="請求年月"
                                        value={util.date.format(
                                          請求年月,
                                          "YYYY/MM"
                                        )}
                                        setValue={set請求年月}
                                        isReadOnly={true}
                                        tabIndex={-1}
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      placeholder="荷主CD"
                                      id="荷主コード"
                                      name="荷主コード"
                                      value={荷主コード}
                                      isReadOnly={true}
                                      style={{ width: "6rem" }}
                                      tabIndex={-1}
                                      setValue={set荷主コード}
                                    />
                                    <TextInput
                                      placeholder="荷主名"
                                      id="荷主名"
                                      name="荷主名"
                                      value={荷主名}
                                      setValue={set荷主名}
                                      maxLength={100}
                                      isReadOnly={true}
                                      tabIndex={-1}
                                      style={{ width: "25rem" }}
                                    />
                                    {/* </div> */}
                                  </div>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      placeholder="表紙名"
                                      id="表紙分割名"
                                      name="表紙分割名"
                                      value={表紙分割名}
                                      setValue={set表紙分割名}
                                      maxLength={100}
                                      isReadOnly={true}
                                      tabIndex={-1}
                                    />
                                    <ComboBox.SeikyuUtiwake
                                      placeholder="請求内訳"
                                      isAllSelect={true}
                                      isRequired={false}
                                      itemsSource={請求内訳ItemSource}
                                      isLoadEnded={請求内訳IsLoadEnded}
                                      setIsLoadEnded={set請求内訳IsLoadEnded}
                                      setSelectedValue={(v) => {
                                        set荷主請求内訳ID(v)
                                      }}
                                      selectedValue={荷主請求内訳ID}
                                      ComboBox={請求内訳ComboBox}
                                      setComboBox={
                                        set請求内訳ComboBox
                                      }></ComboBox.SeikyuUtiwake>
                                  </div>
                                </td>
                                <td>
                                  {/* <div className="w-12rem">
                                  <ComboBox.Kubun
                                    placeholder="請求内訳担当"
                                    分類コード={
                                      区分分類コード.受注配車_請求支払.確認区分
                                    }
                                    itemsSource={区分ItemSource}
                                    isLoadEnded={請求額確認区分isLoadEnded}
                                    isAllSelect={true}
                                    isRequired={false}
                                    setIsLoadEnded={
                                      set請求額確認区分isLoadEnded
                                    }
                                    selectedValue={請求額確認区分コード}
                                    setSelectedValue={(v) => {
                                      set請求額確認区分コード(v)
                                    }}
                                    ComboBox={請求額確認区分ComboBox}
                                    setComboBox={
                                      set請求額確認区分ComboBox
                                    }></ComboBox.Kubun>
                                </div> */}
                                  <div className="w-13rem">
                                    <ComboBox.Syain
                                      placeholder="請求内訳担当"
                                      isLoadEnded={請求内訳担当isLoadEnded}
                                      setIsLoadEnded={
                                        set請求内訳担当isLoadEnded
                                      }
                                      isAllSelect={true}
                                      isRequired={true}
                                      itemsSource={請求内訳担当ItemSource}
                                      selectedValue={請求内訳担当コード}
                                      setSelectedValue={(v) => {
                                        set請求内訳担当コード(v)
                                      }}
                                      ComboBox={請求内訳担当ComboBox}
                                      setComboBox={
                                        set請求内訳担当ComboBox
                                      }></ComboBox.Syain>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <ComboBox.Busyo
                                    placeholder="運行部所"
                                    isLoadEnded={運行部所isLoadEnded}
                                    setIsLoadEnded={set運行部所isLoadEnded}
                                    isAllSelect={true}
                                    isRequired={false}
                                    itemsSource={部所ItemSource}
                                    selectedValue={運行部所コード}
                                    setSelectedValue={(v) => {
                                      set運行部所コード(v)
                                    }}
                                    ComboBox={運行部所ComboBox}
                                    setComboBox={
                                      set運行部所ComboBox
                                    }></ComboBox.Busyo>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      id="積地コード"
                                      name="積地コード"
                                      value={積地コード}
                                      setValue={(v) => {
                                        set積地コード(v)
                                      }}
                                      maxLength={5}
                                      placeholder="積地CD"
                                      style={{ width: "6rem" }}
                                    />
                                    <TextInput
                                      id="積地"
                                      name="積地社名"
                                      value={積地社名}
                                      setValue={set積地社名}
                                      maxLength={100}
                                      placeholder="積場所名"
                                    />
                                    <TextInput
                                      id="積地"
                                      name="積地地名"
                                      value={積地地名}
                                      setValue={set積地地名}
                                      maxLength={100}
                                      placeholder="積地市区町村"
                                      style={{ width: "10rem" }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      id="品コード"
                                      name="品コード"
                                      value={品コード}
                                      setValue={(v) => {
                                        set品コード(v)
                                      }}
                                      maxLength={5}
                                      placeholder="品CD"
                                      style={{ width: "6rem" }}
                                    />
                                    <TextInput
                                      id="品名"
                                      name="品名"
                                      value={品名}
                                      setValue={set品名}
                                      maxLength={100}
                                      placeholder="品名"
                                    />
                                    &nbsp;
                                    <TextInput
                                      id="荷主依頼No"
                                      name="荷主依頼No"
                                      value={荷主依頼番号}
                                      setValue={set荷主依頼番号}
                                      maxLength={50}
                                      placeholder="荷主依頼No"
                                      style={{ width: "13rem" }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="w-13rem">
                                    <ComboBox.Kubun
                                      placeholder="請求額確認"
                                      分類コード={
                                        区分分類コード.受注配車_請求支払
                                          .請求支払確認区分
                                      }
                                      itemsSource={区分ItemSource}
                                      isLoadEnded={請求額確認区分isLoadEnded}
                                      isAllSelect={true}
                                      isRequired={false}
                                      setIsLoadEnded={
                                        set請求額確認区分isLoadEnded
                                      }
                                      selectedValue={請求額確認区分コード}
                                      setSelectedValue={(v) => {
                                        set請求額確認区分コード(v)
                                      }}
                                      ComboBox={請求額確認区分ComboBox}
                                      setComboBox={
                                        set請求額確認区分ComboBox
                                      }></ComboBox.Kubun>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <ComboBox.Kubun
                                    placeholder="表示順"
                                    分類コード={
                                      区分分類コード.受注配車_請求支払
                                        .請求明細一覧表示順区分
                                    }
                                    itemsSource={区分ItemSource}
                                    isLoadEnded={表示順区分isLoadEnded}
                                    isAllSelect={false}
                                    isRequired={false}
                                    setIsLoadEnded={set表示順区分isLoadEnded}
                                    selectedValue={表示順区分コード}
                                    setSelectedValue={(v) => {
                                      set表示順区分コード(v)
                                    }}
                                    ComboBox={表示順区分ComboBox}
                                    setComboBox={
                                      set表示順区分ComboBox
                                    }></ComboBox.Kubun>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      id="卸地コード"
                                      name="卸地コード"
                                      value={卸地コード}
                                      setValue={(v) => {
                                        set卸地コード(v)
                                      }}
                                      maxLength={5}
                                      placeholder="卸地CD"
                                      style={{ width: "6rem" }}
                                    />
                                    <TextInput
                                      id="卸地"
                                      name="卸地社名"
                                      value={卸地社名}
                                      setValue={set卸地社名}
                                      maxLength={100}
                                      placeholder="卸場所名"
                                    />
                                    <TextInput
                                      id="卸地"
                                      name="卸地地名"
                                      value={卸地地名}
                                      setValue={set卸地地名}
                                      maxLength={100}
                                      placeholder="卸地市区町村"
                                      style={{ width: "10rem" }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      id="車番"
                                      name="車番"
                                      value={車番}
                                      setValue={set車番}
                                      maxLength={100}
                                      placeholder="車番"
                                      style={{ width: "6rem" }}
                                    />
                                    <TextInput
                                      id="乗務員名"
                                      name="乗務員名"
                                      value={乗務員名}
                                      setValue={set乗務員名}
                                      maxLength={100}
                                      placeholder="乗務員"
                                    />
                                    &nbsp;
                                    <TextInput
                                      id="コンテナNo"
                                      name="コンテナNo"
                                      value={コンテナNO}
                                      setValue={setコンテナNO}
                                      maxLength={11}
                                      placeholder="コンテナNo"
                                      style={{ width: "13rem" }}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <span className={"align-middle"}>
                                    <CheckInput
                                      id="傭車"
                                      type={"switch"}
                                      label={"傭車"}
                                      setValue={(v) =>
                                        set傭車会社あり対象フラグ(v)
                                      }
                                      value={傭車会社あり対象フラグ}
                                    />
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <Button
                                    type="submit"
                                    disabled={isSearching}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      e.preventDefault()
                                      search()
                                    }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                    検索
                                  </Button>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col xs={12}>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <InvoiceListProvider
                  isSearching={{ state: isSearching, setState: setIsSearching }}
                  isRestoreSearching={{
                    state: isRestoreSearching,
                    setState: setIsRestoreSearching,
                  }}
                  FlexGrid={{
                    state: flexGrid,
                    setState: setFlexGrid,
                  }}
                  SearchResult={searchResult}
                  seikyuGoukeiUpdateDy={{
                    state: 請求合計更新日時,
                    setState: set請求合計更新日時,
                  }}
                  seikyuSyoriStatKbn={{
                    state: 請求処理状態区分コード,
                    setState: set請求処理状態区分コード,
                  }}
                  seikyuDy={{
                    state: 請求年月,
                    setState: set請求年月,
                  }}
                  gridInitialized={{
                    state: gridInitialized,
                    setState: setGridInitialized,
                  }}>
                  <InvoiceListGrid
                    gridId={gridId}
                    区分ItemSource={区分ItemSource}></InvoiceListGrid>
                </InvoiceListProvider>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              disabled={isSearching}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {`更新`}
            </Button>
          </Col>
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </>
  )
}

export default InvoiceList
